import { render } from "./TextInput.vue?vue&type=template&id=4042f098&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=4042f098&scoped=true&lang=css"

import exportComponent from "/home/runner/work/etl/etl/outerspace-admin-2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4042f098"]])

export default __exports__